import { BrowserModule } from '@angular/platform-browser';
import { Injector, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RateCardsComponent } from './rate-cards/rate-cards.component';
import { AngularFireModule } from '@angular/fire';
import { environment } from 'src/environments/environment';

import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularFireFunctionsModule } from '@angular/fire/functions';
import { AngularFireDatabaseModule } from '@angular/fire/database';


import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorage, AngularFireStorageModule } from '@angular/fire/storage';
import { MomentModule } from 'ngx-moment';
import { QuotePipe } from './quote.pipe';
import { createCustomElement } from '@angular/elements';
import { FixedConvThirtyComponent } from './fixed-conv-thirty/fixed-conv-thirty.component';
import { FixedFHAThirtyComponent } from './fixed-fhathirty/fixed-fhathirty.component';
import { FixedVAThirtyComponent } from './fixed-vathirty/fixed-vathirty.component';
import { FixedFifteenComponent } from './fixed-fifteen/fixed-fifteen.component';
import { RegisterComponent } from './register/register.component';
import { LoginComponent } from './login/login.component';
import { ProfileComponent } from './profile/profile.component';
import { SliderCalcComponent } from './slider-calc/slider-calc.component';


@NgModule({
  declarations: [
    AppComponent,
    RateCardsComponent,
    QuotePipe,
    FixedConvThirtyComponent,
    FixedFHAThirtyComponent,
    FixedVAThirtyComponent,
    FixedFifteenComponent,
    RegisterComponent,
    LoginComponent,
    ProfileComponent,
    SliderCalcComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule,
    MomentModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    
  ],
  entryComponents :  [
    RateCardsComponent
 ],
  providers: [],
 bootstrap:[
   AppComponent
 ]
})
export class AppModule { 
  constructor(private injector: Injector){ 

  }
  // ngDoBootstrap(){
  //   const el = createCustomElement(RateCardsComponent, {injector : this.injector});
  // customElements.define('rate-widget',el);
  // }
}

